import React, { Fragment , useEffect } from "react";
import { Link } from "react-router-dom";
import Menu from "../components/menu.js";
import Navbar from "../components/navbar.js";
import Footer from "../components/footer.js";
function Service(){
    useEffect(() => {
            document.title = "Services | AA_Digitals"; // Change title
        }, []);
    return(
<Fragment>
<header class="header-one sticky-header">
<Menu></Menu>
<Navbar></Navbar>
    </header>
    
    <section class="breadcrumb-section bgc" style={{backgroundImage: "url(assets/img/bread2.jpg)"}}>
        <div class="container">
            <div class="row align-items-center">
                <div class="col-lg-5 col-md-6">
                    <div class="breadcrumb-text">
                        <span class="title-tag">Welcome to our company</span>
                        <h2 class="page-title">What We Do.</h2>
                    </div>
                </div>
                <div class="col-lg-7 col-md-6">
                    <div class="breadcrumb-nav">
                        <ul>
                            <li><Link to="/">Home</Link></li>
                            <li class="separator">|</li>
                            <li>Service</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section class="service-area section-gap-bottom section-gap-top-90">
        <div class="container">
            <div class="row justify-content-center">
                <div class="col-lg-4 col-md-6 col-sm-10">
                    <div class="service-box-two mt-30">
                        <span class="box-count">01</span>
                        <h4 class="title"><a href="#">Web Developemnt</a></h4>
                        <p>
                            Transforming ideas into dynamic web solutions with cutting-edge technologies and tailored strategies.
                        </p>
                        <a href="#" class="service-link">
                            <i class="fal fa-plus"></i>
                            <span>Read More</span>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-10">
                    <div class="service-box-two mt-30">
                        <span class="box-count">02</span>
                        <h4 class="title"><a href="#">Graphical Designing</a></h4>
                        <p>
                            Elevate your brand with captivating and innovative graphic design solutions that inspire and engage effectively.
                        </p>
                        <a href="#" class="service-link">
                            <i class="fal fa-plus"></i>
                            <span>Read More</span>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-10">
                    <div class="service-box-two mt-30">
                        <span class="box-count">03</span>
                        <h4 class="title"><a href="#">Logo Creation</a></h4>
                        <p>
                            We design distinctive and memorable logos that capture your essence and leave a lasting impression.
                        </p>
                        <a href="#" class="service-link">
                            <i class="fal fa-plus"></i>
                            <span>Read More</span>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-10">
                    <div class="service-box-two mt-30">
                        <span class="box-count">04</span>
                        <h4 class="title"><a href="#">Poster Designing</a></h4>
                        <p>
                            Discover the art of captivating communication with us' bespoke poster designs. From concept to creation, we craft visuals that resonate and inspire.
                        </p>
                        <a href="#" class="service-link">
                            <i class="fal fa-plus"></i>
                            <span>Read More</span>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-10">
                    <div class="service-box-two mt-30">
                        <span class="box-count">05</span>
                        <h4 class="title"><a href="#">VFX</a></h4>
                        <p>
                            We optimize VFX content to stand out brilliantly, ensuring your visuals reach the right audience effectively and impactfully with precision and creativity.
                        </p>
                        <a href="#" class="service-link">
                            <i class="fal fa-plus"></i>
                            <span>Read More</span>
                        </a>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-10">
                    <div class="service-box-two mt-30">
                        <span class="box-count">06</span>
                        <h4 class="title"><a href="#">Photography</a></h4>
                        <p>
                            "Capture moments, create memories.Our photography brings your vision to life with creativity and precision, ensuring every shot tells a compelling story."
                        </p>
                        <a href="#" class="service-link">
                            <i class="fal fa-plus"></i>
                            <span>Read More</span>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </section>
    
    <section class="skill-section section-gap-bottom grey-bg">
        
        <div class="container section-gap-top">
            <div class="pie-charts">
                <div class="single-pie-chart">
                    <div class="chart" data-percent="100" data-bar-color="#fff">
                        <span>100</span>
                    </div>
                    <h4 class="title">Work Progress</h4>
                    <p>Stay updated with our ongoing projects and their development progress.</p>
                </div>
                <div class="single-pie-chart">
                    <div class="chart" data-percent="100" data-bar-color="#fff">
                        <span>100</span>
                    </div>
                    <h4 class="title">Cost-effective</h4>
                    <p>Experience quality service tailored to your needs, all at an accessible price point that doesn't compromise on excellence.</p>
                </div>
                <div class="single-pie-chart">
                    <div class="chart" data-percent="100" data-bar-color="#fff">
                        <span>100</span>
                    </div>
                    <h4 class="title">Client Statifaction</h4>
                    <p>Client satisfaction is our top priority, ensuring every interaction exceeds expectations.</p>
                </div>
                <div class="single-pie-chart">
                    <div class="chart" data-percent="100" data-bar-color="#fff">
                        <span>100</span>
                    </div>
                    <h4 class="title">On Time</h4>
                    <p>We deliver on time, every time, ensuring reliability and peace of mind for our clients.</p>
                </div>
            </div>
        </div>
    </section>
   
    <Footer></Footer>
</Fragment>
    )
}
export default Service;